module.exports = __webpack_public_path__ + "img/RLiburnian64_ua.87dc1505.webp";